'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DirectionalFooter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _ProgressIndicator = require('../ProgressIndicator');

var _ProgressIndicator2 = _interopRequireDefault(_ProgressIndicator);

var _ProgressStep = require('../ProgressStep');

var _ProgressStep2 = _interopRequireDefault(_ProgressStep);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function DirectionalFooter(props) {
  var onBack = props.onBack,
      onNext = props.onNext,
      currentStep = props.currentStep,
      isBackButtonDisabled = props.isBackButtonDisabled,
      isNextButtonDisabled = props.isNextButtonDisabled;

  var getLabel = function getLabel() {
    if (currentStep === 'step-4') {
      return 'Start Import';
    }

    return 'Next';
  };

  return _react2.default.createElement('div', {
    className: 'rainbow-import-records-flow_footer'
  }, _react2.default.createElement(_Button2.default, {
    className: 'rainbow-import-records-flow_footer-back-button',
    label: 'Back',
    onClick: onBack,
    disabled: isBackButtonDisabled
  }), _react2.default.createElement(_ProgressIndicator2.default, {
    currentStepName: currentStep
  }, _react2.default.createElement(_ProgressStep2.default, {
    name: 'step-1'
  }), _react2.default.createElement(_ProgressStep2.default, {
    name: 'step-2'
  }), _react2.default.createElement(_ProgressStep2.default, {
    name: 'step-3'
  }), _react2.default.createElement(_ProgressStep2.default, {
    name: 'step-4'
  })), _react2.default.createElement(_Button2.default, {
    className: 'rainbow-import-records-flow_footer-next-button',
    label: getLabel(),
    variant: 'brand',
    onClick: onNext,
    disabled: isNextButtonDisabled
  }));
}

DirectionalFooter.propTypes = {
  onBack: _propTypes2.default.func,
  onNext: _propTypes2.default.func,
  currentStep: _propTypes2.default.string,
  isBackButtonDisabled: _propTypes2.default.bool,
  isNextButtonDisabled: _propTypes2.default.bool
};
DirectionalFooter.defaultProps = {
  onBack: function onBack() {},
  onNext: function onNext() {},
  currentStep: undefined,
  isBackButtonDisabled: false,
  isNextButtonDisabled: false
};